import { map } from 'rxjs';
import getUnixTime from 'date-fns/getUnixTime';
import { ADMIN_API } from '../AdminAPI';
import { convertUnixToDate } from '@golden/gdk-base';
import { depositStatusMapAdminDepositStatus } from '../constants/depositStatusMapAdminDepositStatus';
export function createDepositService(api) {
    return {
        getCourierList() {
            return api.fetch(ADMIN_API.GET_THIRD_PARTY_DEPOSIT_COURIER_SIMPLE_LIST);
        },
        getBankList() {
            return api.fetch(ADMIN_API.GET_DEPOSIT_BANK_SIMPLE_LIST);
        },
        getDepositSlipList(payload) {
            const data = { ...payload };
            if (data.created_at_start)
                data.created_at_start = getUnixTime(data.created_at_start);
            if (data.created_at_end)
                data.created_at_end = getUnixTime(data.created_at_end);
            if (data.finished_at_start)
                data.finished_at_start = getUnixTime(data.finished_at_start);
            if (data.finished_at_end)
                data.finished_at_end = getUnixTime(data.finished_at_end);
            return api.fetch(ADMIN_API.GET_DEPOSIT_SLIP_LIST, { data })
                .pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => ({
                    ...convertUnixToDate(item, 'created_at', 'finished_at'),
                    status: depositStatusMapAdminDepositStatus[item.status]
                }))
            })));
        },
        confirmDepositSlip(id, confirm) {
            return api.fetch(ADMIN_API.POST_DEPOSIT_SLIP_STATUS, { data: { confirm }, config: { urlParams: { id } } });
        },
        getThirdPartyDepositSlipSummary(payload) {
            const data = { ...payload };
            if (data.created_at_start)
                data.created_at_start = getUnixTime(data.created_at_start);
            if (data.created_at_end)
                data.created_at_end = getUnixTime(data.created_at_end);
            if (data.finished_at_start)
                data.finished_at_start = getUnixTime(data.finished_at_start);
            if (data.finished_at_end)
                data.finished_at_end = getUnixTime(data.finished_at_end);
            return api.fetch(ADMIN_API.GET_THIRD_PARTY_DEPOSIT_SLIP_SUMMARY, { data });
        },
        getThirdPartyDepositSlipPlayerList(payload) {
            const data = { ...payload };
            if (data.created_at_start)
                data.created_at_start = getUnixTime(data.created_at_start);
            if (data.created_at_end)
                data.created_at_end = getUnixTime(data.created_at_end);
            if (data.finished_at_start)
                data.finished_at_start = getUnixTime(data.finished_at_start);
            if (data.finished_at_end)
                data.finished_at_end = getUnixTime(data.finished_at_end);
            return api.fetch(ADMIN_API.GET_THIRD_PARTY_DEPOSIT_SLIP_PLAYER_LIST, { data })
                .pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => ({
                    ...convertUnixToDate(item, 'created_at', 'finished_at'),
                    status: depositStatusMapAdminDepositStatus[item.status]
                }))
            })));
        },
        getThirdPartyDepositSlipAgentList(payload) {
            const data = { ...payload };
            if (data.created_at_start)
                data.created_at_start = getUnixTime(data.created_at_start);
            if (data.created_at_end)
                data.created_at_end = getUnixTime(data.created_at_end);
            if (data.finished_at_start)
                data.finished_at_start = getUnixTime(data.finished_at_start);
            if (data.finished_at_end)
                data.finished_at_end = getUnixTime(data.finished_at_end);
            return api.fetch(ADMIN_API.GET_THIRD_PARTY_DEPOSIT_SLIP_AGENT_LIST, { data })
                .pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => ({
                    ...convertUnixToDate(item, 'created_at', 'finished_at'),
                    status: depositStatusMapAdminDepositStatus[item.status]
                }))
            })));
        },
        confirmThirdPartyDepositSlipPlayer(id, confirm) {
            return api.fetch(ADMIN_API.POST_THIRD_PARTY_DEPOSIT_SLIP_STATUS_PLAYER, { data: { confirm }, config: { urlParams: { id } } });
        },
        confirmThirdPartyDepositSlipAgent(id, confirm) {
            return api.fetch(ADMIN_API.POST_THIRD_PARTY_DEPOSIT_SLIP_STATUS_AGENT, { data: { confirm }, config: { urlParams: { id } } });
        },
        getDepositError(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_DEPOSIT_ERROR, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        triggerPlayerDetectLostAll(data) {
            return api.fetch(ADMIN_API.POST_BARRIERS_DETECT, { data });
        }
    };
}
//# sourceMappingURL=DepositService.js.map